export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    // 获取房源推广配置
    getPromoteConfigList: function getPromoteConfigList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/house/promote/config/list/",
        method: "get",
        params: data
      });
    },
    // 获取推广单条配置
    getPromoteConfig: function getPromoteConfig() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/house/promote/config/group/",
        method: "get",
        params: data
      });
    },
    // 设置推广单条配置
    setPromoteConfig: function setPromoteConfig() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/house/promote/config/group/",
        method: "post",
        data: data
      });
    },
    // 设置城市档位
    updateCityGroup: function updateCityGroup() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/house/promote/config/city/",
        method: "post",
        data: data
      });
    },
    // 获取城市档位
    getCityGroup: function getCityGroup() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/house/promote/config/city/",
        method: "get",
        params: data
      });
    },
    // 推广列表
    getPromoteListV2: function getPromoteListV2() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/house/promote/list/",
        method: "get",
        params: data
      });
    },
    // 更新推广订单
    updatePromote: function updatePromote() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/house/promote/".concat(data.id, "/"),
        method: "post",
        data: data
      });
    },
    // 获取房源推广配置
    getPromoteSetting: function getPromoteSetting() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/promote_setting/get",
        method: "get",
        params: data
      });
    },
    // 添加房源推广配置
    addPromoteSetting: function addPromoteSetting() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/promote_setting/add",
        method: "post",
        data: data
      });
    },
    // 修改房源推广配置
    updatePromoteSetting: function updatePromoteSetting() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/promote_setting/update",
        method: "post",
        data: data
      });
    },
    // 获取房源推广列表
    getPromoteList: function getPromoteList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/promote/get",
        method: "get",
        params: data
      });
    },
    // 修改房源推广状态
    updatePromoteStatus: function updatePromoteStatus() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/promote/update",
        method: "post",
        data: data
      });
    },
    //推广季度分检查
    promotionCheck: function promotionCheck() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/quarter/promotionCheck",
        method: "post",
        data: data
      });
    }
  };
});